export default __webpack_public_path__ + "static/media/snapchat.6b33ffb7.svg";